// GET targets list

export const FETCH_TARGET_LIST_REQUEST = "FETCH_TARGET_LIST_REQUEST";
export const FETCH_TARGET_LIST_SUCCESS = "FETCH_TARGET_LIST_SUCCESS";
export const FETCH_TARGET_LIST_FAILURE = "FETCH_TARGET_LIST_FAILURE";

// GET target details
export const FETCH_TARGET_REQUEST = "FETCH_TARGET_REQUEST";
export const FETCH_TARGET_SUCCESS = "FETCH_TARGET_SUCCESS";
export const FETCH_TARGET_FAILURE = "FETCH_TARGET_FAILURE";
export const FETCH_TARGET_RESET = "FETCH_TARGET_RESET";

// POST data target
export const POST_DATATARGET_REQUEST = "POST_DATATARGET_REQUEST";
export const POST_DATATARGET_SUCCESS = "POST_DATATARGET_SUCCESS";
export const POST_DATATARGET_FAILURE = "POST_DATATARGET_FAILURE";

// PUT data target
export const PUT_DATATARGET_REQUEST = "PUT_DATATARGET_REQUEST";
export const PUT_DATATARGET_SUCCESS = "PUT_DATATARGET_SUCCESS";
export const PUT_DATATARGET_FAILURE = "PUT_DATATARGET_FAILURE";

// DELETE data target
export const DELETE_TARGET_REQUEST = "DELETE_TARGET_REQUEST";
export const DELETE_TARGET_SUCCESS = "DELETE_TARGET_SUCCESS";
export const DELETE_TARGET_FAILURE = "DELETE_TARGET_FAILURE";

